import { render, staticRenderFns } from "./OrdersCustomerTab.vue?vue&type=template&id=14d5371e"
import script from "./OrdersCustomerTab.vue?vue&type=script&lang=js"
export * from "./OrdersCustomerTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports